import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/product_design_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  number_cont: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.number',
  },
  plate_making_type_eq: {
    column_type: 'enum',
    extra: {
      options: ['original', 'reproduction', 'pre_production', 'fabric_craft', 'paper_pattern', 'pre_quotation'],
    },
    model_name: 'ProductDesign',
    label_key_path: 'productDesign.plateMakingType',
  },
  design_type_eq: {
    column_type: 'enum',
    extra: {
      options: ['custom', 'men', 'women'],
    },
    model_name: 'ProductDesign',
    label_key_path: 'productDesign.designType',
  },
  state_eq: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.stateEq',
  },
  state_in: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.stateIn',
  },
  fabric_state_in: {
    column_type: 'enum',
    extra: {
      options: ['unknown', 'needless', 'pending', 'confirmed', 'completed'],
    },
    model_name: 'ProductDesign',
    label_key_path: 'productDesign.fabricState',
  },
  accessory_state_in: {
    column_type: 'enum',
    extra: {
      options: ['unknown', 'needless', 'pending', 'confirmed', 'completed'],
    },
    model_name: 'ProductDesign',
    label_key_path: 'productDesign.accessoryState',
  },
  designer_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'productDesign.designer',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'ProductDesign',
  },
  designer: {
    column_type: 'belongs_to',
    label_key_path: 'productDesign.designer',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'ProductDesign',
  },
  cheif_pattern_making_officier_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'productDesign.cheifPatternMakingOfficier',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'ProductDesign',
  },
  cheif_pattern_making_officier: {
    column_type: 'belongs_to',
    label_key_path: 'productDesign.cheifPatternMakingOfficier',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'ProductDesign',
  },
  supplier_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'productDesign.supplier',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'ProductDesign',
  },
  supplier: {
    column_type: 'belongs_to',
    label_key_path: 'productDesign.supplier',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'ProductDesign',
  },
  pattern_maker_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'productDesign.patternMaker',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'ProductDesign',
  },
  pattern_maker: {
    column_type: 'belongs_to',
    label_key_path: 'productDesign.patternMaker',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'ProductDesign',
  },
  pattern_factory_eq: {
    column_type: 'enum',
    extra: {
      options: ['pattern', 'cooperative_pattern', 'semi_finished_pattern'],
    },
    model_name: 'ProductDesign',
    label_key_path: 'productDesign.patternFactory',
  },
  company_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'productDesign.company',
    extra: {
      model_name: 'Company',
      display_column: 'name',
    },
    model_name: 'ProductDesign',
  },
  company: {
    column_type: 'belongs_to',
    label_key_path: 'productDesign.company',
    extra: {
      model_name: 'Company',
      display_column: 'name',
    },
    model_name: 'ProductDesign',
  },
  company_id_in: {
    column_type: 'belongs_to',
    label_key_path: 'productDesign.company',
    extra: {
      model_name: 'Company',
      display_column: 'name',
    },
    model_name: 'ProductDesign',
  },
  id_in: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.id',
  },
  overdue_state: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.overdueState',
  },
  audited_on_eq: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.auditedOnEq',
  },
  date_range_between: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.dateRangeBetween',
  },
}
export const formColumnsConfig = {
  'self': {
    'number': { required: true, disabledUpdate: false },
    'design_type': { required: true, disabledUpdate: false },
    'publication_on': { required: true, disabledUpdate: false },
    'pattern_type': { required: true, disabledUpdate: false },
    'plate_making_type': { required: true, disabledUpdate: true },
    'customer_name': { required: false, disabledUpdate: false },
    'remark': { required: false, disabledUpdate: false },
    'company_id': { required: false, disabledUpdate: false },
    'designer_id': { required: false, disabledUpdate: false },
    'files': { required: false, disabledUpdate: false },
    'images': { required: true, disabledUpdate: false },
    'pattern_factory': { required: false, disabledUpdate: true },
    'product_design_item_table_attributes': { required: true, disabledUpdate: false },
  },
  'product_design_item_table_attributes': {
    'quantity': { required: true, disabledUpdate: false },
    'color': { required: true, disabledUpdate: false },
    'size_option_value_id': { required: true, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('ProductDesign', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('ProductDesign', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
